var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 748,
    height: 633,
    viewBox: "0 0 748 633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c,.e{fill:none;}.c{stroke:currentColor;}.d{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 374,
    cy: 316.5,
    rx: 374,
    ry: 316.5,
    transform: "translate(-0.337)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.337)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(887.635 -66.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 88.813)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 826.159
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 825.159
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(368 74.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 827.283
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 826.283
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(184 167.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 692.378
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 691.378
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(552 167.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 692.378
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 691.378
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(92 167.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 692.378
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 691.378
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(460 61.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 935.207
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 934.207
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(276 74.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 864.382
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 863.382
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(644)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 93,
    height: 962.188
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 961.188
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.156 -141.44)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 615.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 614.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(413.709 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 735.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 734.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(206.855 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 615.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 614.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(620.564 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 615.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 614.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(103.427 149)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 615.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 614.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(517.137 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 831.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 830.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(310.282 66)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 768.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 767.879
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(723.992)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 104.552,
    height: 855.879
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 103.552,
    height: 854.879
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.ee89a4268ad24c9bc5d737a5b7cdfb9c.svg";
export { ForwardRef as ReactComponent };